import React from 'react'
import {
  Row,
  Col,
  Form,
  Select,
  Radio,
  Table,
  Spin,
  Button,
  Icon,
  Upload,
} from 'antd'
import {UploadOutlined} from '@ant-design/icons'
import Layouts from '../components/Layouts'
import {useState, useEffect} from 'react'
import 'react-toastify/dist/ReactToastify.css'
import apiRequest from '../hooks/apiRequest'
import {useParams} from 'react-router-dom/cjs/react-router-dom.min'
import {toast} from 'react-toastify'
const {Option} = Select
function ApproveClaim(props) {
  const [obj, setObj] = useState({
    insurerId: '',
  })
  const productID = Number(localStorage.getItem('productId'))
  const [lossDate, setlossDate] = useState(new Date())
  const [radiovalue, setValue] = React.useState(productID)
  const [searchData, setSearchData] = useState([])
  const [policydetail, setpolicydetail] = useState()
  const [loading, setLoading] = useState(false)
  const [items, setItems] = useState()
  const [policyNumber, setPolicyNumber] = useState()
  const [startDate, setStartDate] = useState()
  const [paymentStatus, setPaymentStatus] = useState([])
  const [productId, setProductId] = useState()
  const [paymentOTMstatus, setpaymentOTMstatus] = useState()
  const [productList, setProductList] = useState([])
  const [customerDetail, setCustomerDetail] = useState()
  const [emailBody, setEmailBody] = useState()
  const [ClaimDetail, SetClaimDetail] = useState({})
  const [fileList, setFileList] = useState([])
  const ClaimId = useParams()
  console.log('ClaimId', ClaimId)
  const onMotorChange = e => {
    setValue(e.target.value)
    setProductId(e.target.value)
    setSearchData([])
  }
  const onhandleChange = async val => {
    setLoading(true)
    let policyData
    let fetchURL = ''

    if (radiovalue !== 6 && !val.includes('OTM')) {
      // fetchURL = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/GetPolicybynumber/${val},${productId}`;
      fetchURL = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/GetPolicybynumber/${val}`
    } else if (radiovalue === 6 && val.includes('OTM')) {
      fetchURL = `${process.env.REACT_APP_BASE_URL_POLICIES}/OTM/Policy/${val}`
    }

    try {
      const response = await apiRequest(fetchURL, 'GET')
      if (response.success) {
        const data = response.data
        if (radiovalue !== 6 && !val.includes('OTM')) {
          setStartDate(data.policydetail.policystartdate)
          setPolicyNumber(data.policydetail.policynumber)
          setPaymentStatus(data.payment_detail)
          setEmailBody(data)
          setObj({insurerId: data?.policydetail?.insurerId})
          const policy_info = data.policydetail.ipolicyInfo
          const extracted_policy_info = JSON.parse(policy_info)
          const quotation_info = JSON.parse(
            extracted_policy_info.IquotationInfo,
          )
          const email_body = {
            customerDetail: {
              customerId: quotation_info.customerid,
              notifyCustomer: quotation_info.customeremail,
            },
            insurerDetail: {
              insurerId: quotation_info.InsurerId,
              notifyInsurer: data.email,
            },
            brokerDetail: {
              brokerId: quotation_info.createdby,
              notifyBroker: quotation_info.BrokerEmail,
            },
          }

          setEmailBody(JSON.stringify(email_body))
          policyData = {
            customerName: data.policydetail.customername,
            policyNo: data.policydetail.policynumber,
            startDate: data.policydetail.policystartdate,
            endDate: data.policydetail.policyexpirytdate,
            premium: data.policydetail.proratatotaltermpremium,
            vrn: '',
            riskItemDetails: data.policydetail.riskitemdetails,
            sumInsured: '',
            policyNumber: data?.policydetail?.policynumber,
          }

          const itemNames = data.policydetail.riskitemdetails.map(
            item => item.riskitemname,
          )
          setItems(itemNames)
        } else if (radiovalue === 6 && val.includes('OTM')) {
          policyData = {
            customerName: `${data.first_name} ${data.surname}`,
            policyNo: data.policy_number,
            startDate: data.policy_start_date,
            endDate: data.policy_end_date,
            premium: data.premium,
            vrn: data.vrn,
            riskItemDetails: '',
            sumInsured: data.sum_insured,
            policyNumber: data?.policydetail?.policynumber,
          }

          setpaymentOTMstatus(data.payment_status.toLowerCase())
          setItems('')
        }
        // debugger

        setCustomerDetail(data.customerdetail)
        setpolicydetail(policyData)
      } else {
        console.error('API Error:', response.error)
      }
    } catch (error) {
      console.error('Error fetching policy data:', error)
    } finally {
      setLoading(false)
    }
  }
  const onSearch = async value => {
    if (!value || value.length === 0) return

    try {
      if (radiovalue !== 6 && !value.includes('OTM')) {
        // const url = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/search/${value},${productId}`;
        const url = `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/search/${value}`
        const response = await apiRequest(url, 'GET')

        if (response.success) {
          setSearchData(response.data)
        } else {
          console.error('Search failed:', response.error)
        }
      } else if (radiovalue === 6 && value.includes('OTM')) {
        const url = `http://64.227.72.205:5001/api/v1/policy/${value}`
        const response = await apiRequest(url, 'GET')

        if (response.success) {
          const data = response.data
          setSearchData([
            {
              policynumber: data.policy_number,
              nationalid: data.id_number,
              customername: `${data.first_name} ${data.surname}`,
            },
          ])
        } else {
          console.error('OTM policy search failed:', response.error)
        }
      }
    } catch (error) {
      console.error('Unhandled error in onSearch:', error)
    }
  }
  // Fetch Claim Detail
  const fetchEditClaim = async id => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Claim/GetClaimById/${id}`,
        'GET',
      )
      const data = response?.data?.result?.claim_creation
      SetClaimDetail(data)
      if (data) {
      }
    } catch (error) {
      console.error('Failed to fetch claim data:', error)
    }
  }
  useEffect(() => {
    onhandleChange(ClaimId?.policyNumber)
    fetchEditClaim(ClaimId?.id)
  }, [])
  const options = searchData.map(d => (
    <Select.Option key={d.policynumber}>
      {d.policynumber} - {d.customername} - {d.nationalid}
    </Select.Option>
  ))
  const columns = [
    {
      title: 'Policy Cover(s)',
      key: '1',
      render: x => x.policy_cover,
    },
    {
      title: 'Claim Item(s)',
      key: '2',
      render: x => x.riskitemname,
    },
    {
      title: 'Sum Insured',
      render: x => x.suminsured,
      key: '3',
    },
    {
      title: 'Premium',
      render: x => x.prorata,
      key: '4',
    },
  ]
  const columnsFCP = [
    {
      title: 'Policy Cover(s)',
      key: '1',
      render: x => x.policy_cover,
    },
    {
      title: 'Claim Item(s)',
      key: '2',
      render: x => x.riskitemname,
    },
    {
      title: 'Sum Insured',
      render: x => x.suminsured,
      key: '3',
    },
    {
      title: 'Monthly Premium',
      render: x => x.monthlypremium,
      key: '4',
    },
  ]
  const fetchData = async () => {
    const List = await apiRequest(
      process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetAllProducts',
    )
    console.log(List?.data)
    setProductList(List?.data?.data)
  }
  useEffect(() => {
    fetchData()
  }, [])

  // Send Mail To client for add detail
  const handleSubmit = async () => {
    setLoading(true)
    try {
      if (ClaimDetail?.claim_status === 'Approved') {
        // If claim already approved, then upload proof
        if (!fileList) {
          //   message.error('Please upload proof of payment.')
          setLoading(false)
          return
        }
        const formData = new FormData()
        formData.append('claimId', ClaimId?.id)
        formData.append('file', fileList[0]?.originFileObj)
        const res = await apiRequest(
          `${process.env.REACT_APP_BASE_URL}/Claim/SettleClaimWithUpload/settle-claim-with-upload`,
          'POST',
          formData,
        )
        if (res.success) {
          toast.success('Claim setteled successfully.')
          window.location.href = '/claims'
        } else {
          toast.error(res.error || 'Something went wrong.')
        }
      } else {
        // Otherwise, call the original claim approval API
        const url = `${process.env.REACT_APP_BASE_URL}/Claim/ApproveClaim/approve-claim?claimId=${ClaimId?.id}`
        const res = await apiRequest(url, 'POST')

        if (res.success) {
          toast.success('Claim approved successfully.')
          window.location.href = '/claims'
        } else {
          toast.error(res.error || 'Something went wrong.')
        }
      }
    } catch (err) {
      console.error('Submit error:', err)
      //   message.error('Request failed. Try again.')
    } finally {
      setLoading(false)
    }
  }
  const handleUploadChange = ({fileList}) => {
    const latestFile = fileList.slice(-1)
    setFileList(latestFile)
    props.form.setFieldsValue({
      proofOfPayment: latestFile.length ? latestFile : null,
    })
  }
  return (
    <Layouts title="assets" classname="grid">
      <Spin
        className="loader-icon-fixed"
        spinning={loading}
        size="large"></Spin>
      <div>
        <div style={{padding: '10px'}}>
          <div className="align-right">
            <Row gutter={4}>
              <Col xs={12} sm={24} md={12} lg={24}>
                <Radio.Group
                  onChange={onMotorChange}
                  value={radiovalue}
                  style={{margin: '0px 0px 10px 0px'}}>
                  {productList &&
                    productList?.map(elem => (
                      <Radio value={elem?.productid}>{elem?.productname}</Radio>
                    ))}
                </Radio.Group>{' '}
                <Select
                  className="ant-input-bx"
                  showSearch
                  placeholder="Search"
                  // style={this.props.style}
                  defaultActiveFirstOption={false}
                  showArrow={false}
                  filterOption={false}
                  onSearch={onSearch}
                  onChange={onhandleChange}
                  notFoundContent={null}>
                  {options}
                </Select>
              </Col>
            </Row>
          </div>
        </div>

        <div>
          <div className=" dash-bg-white">
            <h2
              style={{
                color: '#F15A2B',
                fontWeight: '500',
                fontSize: '20px',
                marginBottom: '15px',
              }}>
              <strong>
                Claim Details{' '}
                <label
                  style={{
                    color: '#F15A2B',
                    fontWeight: '700',
                    fontSize: '20px',
                  }}></label>
              </strong>
            </h2>
            {ClaimDetail && (
              <>
                <Row gutter={[12, 12]}>
                  <Col xs={24} md={12} lg={6}>
                    <label>
                      <b>Claim Number : </b> {ClaimDetail?.claim_number}
                    </label>
                  </Col>
                  <Col xs={24} md={12} lg={6}>
                    <label>
                      <b>Claim Amount.: </b> {ClaimDetail?.claim_amount}
                    </label>
                  </Col>
                  <Col xs={24} md={12} lg={6}>
                    <label>
                      <b>Item Detail: </b> {ClaimDetail.itemdetails}
                    </label>
                  </Col>
                  {radiovalue !== 3 && (
                    <Col xs={24} md={12} lg={6}>
                      <label>
                        <b>Date of Loss : </b> {ClaimDetail?.date_of_loss}
                      </label>
                    </Col>
                  )}
                </Row>
              </>
            )}
            <h2
              style={{
                color: '#F15A2B',
                fontWeight: '500',
                fontSize: '20px',
                marginBottom: '15px',
              }}>
              <strong>
                Policy Details{' '}
                <label
                  style={{
                    color: '#F15A2B',
                    fontWeight: '700',
                    fontSize: '20px',
                  }}></label>
              </strong>
            </h2>
            {policydetail && (
              <>
                <Row gutter={[12, 12]}>
                  <Col xs={24} md={12} lg={6}>
                    <label>
                      <b>Customer Name : </b>{' '}
                      {policydetail && policydetail.customerName}
                    </label>
                  </Col>
                  <Col xs={24} md={12} lg={6}>
                    <label>
                      <b>Policy No.: </b>{' '}
                      {policydetail && policydetail.policyNo}
                    </label>
                  </Col>
                  <Col xs={24} md={12} lg={6}>
                    <label>
                      <b>Start date : </b>{' '}
                      {policydetail && policydetail.startDate}
                    </label>
                  </Col>
                  {radiovalue !== 3 && (
                    <Col xs={24} md={12} lg={6}>
                      <label>
                        <b>End date : </b>{' '}
                        {policydetail && policydetail.endDate}
                      </label>
                    </Col>
                  )}
                  <Col xs={24} md={12} lg={6}>
                    <label>
                      <b>Payment Status : </b>{' '}
                      {radiovalue === 4
                        ? paymentOTMstatus
                        : paymentStatus.payment_status}
                    </label>
                  </Col>
                  <Col xs={24} md={12} lg={6}>
                    <label>
                      <b>Premium : </b> {policydetail && policydetail.premium}
                    </label>
                  </Col>
                  {policydetail && policydetail.policyNo.includes('OTM') && (
                    <Col xs={24} md={12} lg={6}>
                      <label>
                        <b>VRN : </b> {policydetail && policydetail.vrn}
                      </label>
                    </Col>
                  )}
                </Row>
                {policydetail && !policydetail.policyNo.includes('OTM') && (
                  <div className="table-grid-bx" style={{marginTop: '20px'}}>
                    <Table
                      columns={
                        policydetail.policyNo.includes('OTFCP')
                          ? columnsFCP
                          : columns
                      }
                      dataSource={policydetail && policydetail.riskItemDetails}
                      scroll={{x: 768}}
                      pagination={false}
                    />
                  </div>
                )}
              </>
            )}
            {ClaimDetail && (
              <>
                <Form layout="vertical">
                  {ClaimDetail?.claim_status === 'Approved' && (
                    <Form.Item label="Upload Proof of Payment">
                      {/* <Upload
                        beforeUpload={file => {
                          setFile(file)
                          return false
                        }}
                        fileList={file ? [file] : []}
                        onRemove={() => setFile(null)}>
                        <Button>
                          <Icon type="upload" /> Select File
                        </Button>
                      </Upload> */}
                      <Upload
                        beforeUpload={() => false}
                        fileList={fileList}
                        onChange={handleUploadChange}>
                        <Button icon={<UploadOutlined />}>
                          Upload Proof of payment
                        </Button>
                      </Upload>
                    </Form.Item>
                  )}
                  <br />
                  <Button
                    type="primary"
                    onClick={handleSubmit}
                    loading={loading}>
                    Approve Claim
                  </Button>
                </Form>
              </>
            )}
          </div>
        </div>
      </div>
    </Layouts>
  )
}

export default Form.create()(ApproveClaim)
